export enum TemperatureExcursionIdentifier {
  SIEMENS_EMPLOYEE = 'Siemens Employee',
  IMPORT_CUSTOMS_BROKER = 'Import Customs Broker',
  CARRIER_EMPLOYEE = 'Carrier Employee',
  PORT_EMPLOYEE = 'Port Employee',
  DRIVER = 'Driver',
}
